import { useCallback, useEffect, useState } from 'react';
import { nativeCall } from '../video/nativeApp';

// The Android app «Cherry-Pick» (D:\Android\cherry-pick-app) is updated from
// our own site: /app/version.json says which version is the latest and where
// the APK is. Inside the app the installed version comes from the bridge
// (CoreNative.version()) or the user agent ("CherryPickApp/1.1").

export const APK_URL = '/app/CherryPickCore.apk';

export const isNativeApp = () =>
  typeof window !== 'undefined' &&
  (!!window.CoreNative || /CherryPickApp\//.test(navigator.userAgent || ''));

export function installedVersion() {
  if (!isNativeApp()) return null;
  const v = nativeCall('version');
  if (v) return String(v);
  const m = /CherryPickApp\/([\d.]+)/.exec(navigator.userAgent || '');
  return m ? m[1] : null;
}

// "1.10" > "1.9"
export function isNewer(a, b) {
  const pa = String(a || '0')
    .split('.')
    .map((x) => parseInt(x, 10) || 0);
  const pb = String(b || '0')
    .split('.')
    .map((x) => parseInt(x, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d > 0;
  }
  return false;
}

export async function latestApp() {
  const res = await fetch(`/app/version.json?ts=${Date.now()}`, {
    cache: 'no-store',
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

/* Download and install the new version. Apps from 1.1 download it themselves
   and open the installer; 1.0 lets the WebView download the file (the
   «Загрузка завершена» notification opens the installer). */
export function startUpdate(url = APK_URL) {
  const abs = new URL(url, window.location.origin).href;
  if (window.CoreNative && typeof window.CoreNative.update === 'function') {
    nativeCall('update', abs);
    return 'native';
  }
  window.location.href = abs;
  return 'download';
}

let cache = { at: 0, value: null };

// { installed, latest, outdated, check() } — checked on start, every 6 hours
// and when the app comes back to the screen.
export function useAppUpdate() {
  const [installed] = useState(installedVersion);
  const [latest, setLatest] = useState(cache.value);
  const check = useCallback(
    async (force) => {
      if (!installed) return;
      if (!force && cache.value && Date.now() - cache.at < 30 * 60 * 1000) {
        setLatest(cache.value);
        return;
      }
      try {
        const v = await latestApp();
        cache = { at: Date.now(), value: v };
        setLatest(v);
      } catch (e) {
        // offline — try again later
      }
    },
    [installed]
  );
  useEffect(() => {
    if (!installed) return undefined;
    check();
    const timer = setInterval(() => check(true), 6 * 3600 * 1000);
    const vis = () => document.visibilityState === 'visible' && check();
    document.addEventListener('visibilitychange', vis);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', vis);
    };
  }, [installed, check]);
  return {
    installed,
    latest,
    outdated: Boolean(
      installed && latest && isNewer(latest.version, installed)
    ),
    check,
  };
}
